export const CHECKOUT_URL = 'https://senior-fitness-pro.impultienda.ar/checkout'

export const BOX_IMG =
  'https://cdn.magicpatterns.com/uploads/apzUG2EDzo52ZVAMMjEDSp/ChatGPT-Image-27-jul-2026_-08_08_53-p.m..webp'

export const PRODUCT_NAME = 'SENIOR FITNESS PRO™'

/** Toutes les images et tous les boutons renvoient vers la section d'achat. */
export const BUY_ANCHOR = '#offre'
